import { render, staticRenderFns } from "./Kort.vue?vue&type=template&id=5098d81a&scoped=true"
import script from "./Kort.vue?vue&type=script&lang=js"
export * from "./Kort.vue?vue&type=script&lang=js"
import style0 from "./Kort.vue?vue&type=style&index=0&id=5098d81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5098d81a",
  null
  
)

export default component.exports